



































import Item from './item.vue'

DATA_MIXIN = {
  data: ->
    onLoadPage: false
    page: 1
    perPage: 5
}

export default {
  name: 'ExpertFeedbacksMain'

  mixins: [DATA_MIXIN]

  components: { Item }

  methods:
    onPageChange: (page) ->
      return if @onLoadPage
      @onLoadPage = true
      @page = parseInt(page)
      @retrieveData({ page: @page })

    retrieveData: (_params = {}) ->
      params = _params
      $.ajax({
        url: @indexPath,
        method: 'GET',
        dataType: 'json',
        data: params,
        success: @onRetrieveDataSuccess
      })

    onRetrieveDataSuccess: (data) ->
      @expertFeedbacks = data.expert_feedbacks
      @expertFeedbacksCount = data.expert_feedbacks_count
      @onLoadPage = false

  computed:
    emptyText: ->
      @$i18n('pages.system.idea_groups.empty_list')

    calcPagesCount: ->
      Math.ceil(parseInt(@expertFeedbacksCount) / parseInt(@perPage))

    numberPage:
      get: ->
        parseInt(@page)
      set: (v) ->
        @page = parseInt(v)
}
